export default __webpack_public_path__ + "static/media/GettingStarted.2f245d6c.md";